import React from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { commonPostPutApi } from "../../../redux/reducers/commonApiSlice";
import CommonHeadingNBtns from "../../common-components/CommonHeadingNBtns";

const SubCategoryForm = ({
  token,
  onCloseModal,
  isEdit,
  rowData,
  selectedCategory,
  refetchData,
}) => {
  const dispatch = useDispatch();

  const validationSchema = Yup.object({
    name: Yup.string()
      .required("Sub category name is required")
      .min(2, "Sub category name must be at least 2 characters")
      .max(100, "Sub category name must be less than 100 characters"),
  });

  const formik = useFormik({
    initialValues: {
      name: isEdit ? rowData?.name || "" : "",
    },
    validationSchema,
    onSubmit: async (values, { setSubmitting }) => {
      try {
        if (isEdit) {
          const payload = {
            uid: rowData?.uid,
            category_id: selectedCategory?.uid || rowData?.category_id,
            name: values.name,
          };

          const result = await dispatch(
            commonPostPutApi({
              method: "PUT",
              endpoint: "/ticketSystem/sub-category/update",
              token: token,
              payload: payload,
            })
          );

          if (result?.payload?.status) {
            toast.success(
              result?.payload?.message || "Sub category updated successfully!"
            );
            refetchData();
            onCloseModal();
          } else {
            toast.error(
              result?.payload?.message || "Failed to update sub category"
            );
          }
        } else {
          if (!selectedCategory?.uid) {
            toast.error("Please select a category first");
            return;
          }

          const payload = {
            // category_id: selectedCategory.uid,
            subCategories: [
              { name: values.name, category_id: selectedCategory.uid },
            ],
          };

          const result = await dispatch(
            commonPostPutApi({
              method: "POST",
              endpoint: "/ticketSystem/sub-category/add-multiple",
              token: token,
              payload: payload,
            })
          );

          if (result?.payload?.status) {
            toast.success(
              result?.payload?.message || "Sub category added successfully!"
            );
            refetchData();
            onCloseModal();
          } else {
            toast.error(
              result?.payload?.message || "Failed to add sub category"
            );
          }
        }
      } catch (error) {
        toast.error("An error occurred. Please try again.");
      } finally {
        setSubmitting(false);
      }
    },
  });

  return (
    <div className="createNewCTOModalContainer mod-width-50p">
      <CommonHeadingNBtns
        title={`${isEdit ? "Edit" : "Add"} Sub Category`}
        onClick={formik.handleSubmit}
        isLoading={formik.isSubmitting}
        btnTxt={isEdit ? "Update" : "Add"}
        onClose={onCloseModal}
      />

      <form className="formContainer" onSubmit={formik.handleSubmit}>
        <div className="formInputsGrid twoGridSystem">
          {selectedCategory && (
            <div className="formInputBox">
              <label className="formInputLabel">Category</label>
              <div className="commonWrapper">
                <div className="selected-item-display">
                  {selectedCategory.name}
                </div>
              </div>
            </div>
          )}

          <div className="formInputBox">
            <label htmlFor="name" className="formInputLabel">
              Sub Category Name <span className="required">*</span>
            </label>
            <div className="commonWrapper">
              <input
                type="text"
                id="name"
                name="name"
                className="formInput"
                placeholder="Enter sub category name"
                value={formik.values.name}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
            </div>
            {formik.touched.name && formik.errors.name && (
              <div className="error-message">{formik.errors.name}</div>
            )}
          </div>
        </div>
      </form>
    </div>
  );
};

export default SubCategoryForm;
